import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { ContactDetailsWidgetDisplayMode } from "scrivito/Widgets/ContactDetailsWidget/ContactDetailsWidgetClass"

import "./styles/_contact-details.scss"

interface ContactDetailsViewProps {
  name?: React.ReactNode
  street?: React.ReactNode
  city?: React.ReactNode
  country?: React.ReactNode
  telephone?: React.ReactNode
  fax?: React.ReactNode
  email?: React.ReactNode
  mapsURL?: React.ReactNode
  website?: React.ReactNode
  displayMode?: ContactDetailsWidgetDisplayMode | null
  "data-testid"?: string
}

export const ContactDetailsView = React.memo(
  ({
    name,
    street,
    city,
    country,
    mapsURL,
    website,
    email,
    fax,
    telephone,
    displayMode,
    ...rest
  }: ContactDetailsViewProps) => {
    const { t } = useTranslation()

    return (
      <address
        className={classNames("contact-details", {
          "contact-details--row":
            displayMode === ContactDetailsWidgetDisplayMode.ROW
        })}
        {...rest}
      >
        {name ? <div className="contact-details__name">{name}</div> : null}
        {street ? (
          <div className="contact-details__street">{street}</div>
        ) : null}
        {city ? <div className="contact-details__city">{city}</div> : null}
        {country ? (
          <div className="contact-details__country">{country}</div>
        ) : null}
        {telephone ? (
          <div className="contact-details__telephone">
            {t("ContactDetails.TelephoneShort")}: {telephone}
          </div>
        ) : null}
        {fax ? (
          <div className="contact-details__fax">
            {t("ContactDetails.Fax")}: {fax}
          </div>
        ) : null}
        {email ? (
          <div className="contact-details__email">
            {t("ContactDetails.Email")}: {email}
          </div>
        ) : null}
        {mapsURL ? (
          <div className="contact-details__maps-url">
            {t("ContactDetails.MapsURL")}: {mapsURL}
          </div>
        ) : null}
        {website ? (
          <div className="contact-details__website">{website}</div>
        ) : null}
      </address>
    )
  }
)
